import * as Long from "long";
import { ofType } from "redux-observable";
import { concat, from, of } from "rxjs";
import { delay, retry, switchMap } from "rxjs/operators";
import { selectFinishedQuestRewards, selectFinishedQuestXp, } from "../../../../balancingSelectors/selectBalancingQuests";
import { selectIsLastEpisodeInThemedEvent, selectThemedEvent, } from "../../../../selectors/selectEventInfo";
import { filterNewQuests } from "../../../../selectors/selectQuestInfo";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionThemedEventFinishRequest } from "../../../themed-events/actionThemedEvent";
import { actionInventoryInfoAddResource } from "../../inventory/actionInventoryInfo";
import { actionPlayerInfoAddXp } from "../../player/actionPlayerInfo";
import { actionQuestInfoFinish } from "../actionQuestInfo";
import { actionQuestOpen, actionQuestUpdate, TypeActionQuest, } from "../list/actionQuests";
export var epicQuestFinish = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuest.Finish), switchMap(function (action) {
        var state = state$.value;
        return concat(of(actionQuestInfoFinish({ questId: action.questId })), deps
            .netSend({
            id: CommandCode.QuestFinish,
            props: {
                playerId: state.playerInfo.playerId,
                questId: action.questId,
            },
        })
            .pipe(
        // TODO: remove delay, and add logic to get next quests and recommended quest from balancing instead of waiting for res from server. get code from backend and add to utilQuests
        // delay is added to allow smooth pellet animation
        delay(1250), switchMap(function (res) {
            var actions = [];
            var _a = filterNewQuests(state, res.quest, res.questId), newQuestIds = _a.newQuestIds, newReceivedQuestIds = _a.newReceivedQuestIds;
            if (newReceivedQuestIds.length > 0) {
                newReceivedQuestIds.forEach(function (value) {
                    actions.push(actionQuestOpen(value, newReceivedQuestIds));
                });
            }
            actions.push(actionQuestInfoFinish(res, newQuestIds, false));
            actions.push(actionQuestUpdate(newQuestIds));
            var rewards = selectFinishedQuestRewards(res.questId);
            actions.push(actionInventoryInfoAddResource(rewards));
            var rewardXp = selectFinishedQuestXp(res.questId);
            if (rewardXp && rewardXp.notEquals(Long.ZERO)) {
                actions.push(actionPlayerInfoAddXp(rewardXp));
            }
            var isThemedEventLastQuest = selectIsLastEpisodeInThemedEvent(state, action.questId);
            var themedEvent = selectThemedEvent(state);
            if (isThemedEventLastQuest && themedEvent) {
                actions.push(actionThemedEventFinishRequest(themedEvent.eventId));
            }
            return from(actions);
        }), retry()));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epics/epicQuestFinish.ts
// module id = 1966
// module chunks = 3